import { render, staticRenderFns } from "./Classrooms.vue?vue&type=template&id=a0ed6ed4&scoped=true"
import script from "./Classrooms.vue?vue&type=script&lang=js"
export * from "./Classrooms.vue?vue&type=script&lang=js"
import style0 from "./Classrooms.vue?vue&type=style&index=0&id=a0ed6ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ed6ed4",
  null
  
)

export default component.exports